export class Pawn {
  static getMoves(position, color, gameState) {
    const [row, col] = position;
    const moves = [];
    const direction = color === 'white' ? -1 : 1; // White moves up (-1), black moves down (+1)
    const startRow = color === 'white' ? 7 : 2;
    // const promotionRow = color === 'white' ? 1 : 8;
    
    // Single move forward
    let newRow = row + direction;
    if (newRow >= 1 && newRow <= 8) {
      // Check if square in front is empty
      if (!gameState.isOccupied([newRow, col])) {
        moves.push([newRow, col]);
        
        // Double move from starting position
        if (row === startRow) {
          const newRow2 = row + (direction * 2);
          // Check if both squares are empty
          if (!gameState.isOccupied([newRow2, col]) && !gameState.isOccupied([newRow, col])) {
            moves.push([newRow2, col]);
          }
        }
      }
    }
    
    // Diagonal captures
    [-1, 1].forEach(dCol => {
      const newCol = col + dCol;
      if (newCol >= 1 && newCol <= 8) {
        const newRow = row + direction;
        if (newRow >= 1 && newRow <= 8) {
          const targetPos = [newRow, newCol];
          if (gameState.isOccupied(targetPos)) {
            const targetPiece = gameState.getPiece(targetPos);
            if (targetPiece && targetPiece.color !== color && targetPiece.type !== 'king') {
              moves.push(targetPos);
            }
          } else if (gameState.canEnPassant(position, targetPos, color)) {
            moves.push(targetPos);
          }
        }
      }
    });
    
    return moves;
  }
}
